import { z } from 'zod'

export const PromotionCodeSchema = z.object({
    id: z.string(),
    code: z.string(),
    promotionId: z.string(),
    storeId: z.string(),
    customerId: z.string().nullable(),
    usageCount: z.number().default(0),
    usageLimit: z.number().nullable(),
    expiresAt: z.date().nullable(),
    active: z.boolean().default(true),
    firstTimeCustomersOnly: z.boolean().default(false),
    emailPattern: z.string().nullable(),
    description: z.string().nullable(),
    metadata: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
})

export const PromotionCodeWithPromotionSchema = PromotionCodeSchema.extend({
    promotion: z.object({
        id: z.string(),
        name: z.string(),
        storeId: z.string(),
    }),
})

export const PromotionCodeWithCustomerSchema = PromotionCodeSchema.extend({
    customer: z
        .object({
            id: z.string(),
            email: z.string(),
            firstName: z.string().nullable(),
            lastName: z.string().nullable(),
        })
        .nullable(),
})

export const PromotionCodeWithRelationsSchema = PromotionCodeSchema.extend({
    promotion: z.object({
        id: z.string(),
        name: z.string(),
        storeId: z.string(),
    }),
    customer: z
        .object({
            id: z.string(),
            email: z.string(),
            firstName: z.string().nullable(),
            lastName: z.string().nullable(),
        })
        .nullable(),
})

export const PromotionCodeListItemSchema = PromotionCodeWithRelationsSchema

export const PromotionCodeDetailsSchema = PromotionCodeWithRelationsSchema

export type PromotionCodeType = z.infer<typeof PromotionCodeSchema>
export type PromotionCodeWithPromotionType = z.infer<typeof PromotionCodeWithPromotionSchema>
export type PromotionCodeWithCustomerType = z.infer<typeof PromotionCodeWithCustomerSchema>
export type PromotionCodeWithRelationsType = z.infer<typeof PromotionCodeWithRelationsSchema>
export type PromotionCodeListItemType = z.infer<typeof PromotionCodeListItemSchema>
export type PromotionCodeDetailsType = z.infer<typeof PromotionCodeDetailsSchema>

export const toPromotionCodeDto = (data: any): PromotionCodeType => {
    return PromotionCodeSchema.parse(data)
}

export const toPromotionCodeWithPromotionDto = (
    data: any,
): PromotionCodeWithPromotionType => {
    return PromotionCodeWithPromotionSchema.parse(data)
}

export const toPromotionCodeWithCustomerDto = (
    data: any,
): PromotionCodeWithCustomerType => {
    return PromotionCodeWithCustomerSchema.parse(data)
}

export const toPromotionCodeWithRelationsDto = (
    data: any,
): PromotionCodeWithRelationsType => {
    return PromotionCodeWithRelationsSchema.parse(data)
}

export const toPromotionCodeListItemDto = (data: any): PromotionCodeListItemType => {
    return PromotionCodeListItemSchema.parse(data)
}

export const toPromotionCodeDetailsDto = (data: any): PromotionCodeDetailsType => {
    return PromotionCodeDetailsSchema.parse(data)
}

